const TypeTag = {
  NOT_SUBS: 0,
  BASIC: 1,
  PREMIUM: 2,
  PREMIUM_PLUS: 3
}
export default TypeTag
